<template>
	<div class="wrapper-body flex-1">
		<h1>User Dashboard</h1>
		<v-container fluid>
			<v-row align="center" justify="center" no-gutters>
				<v-col cols="12" sm="6">
					<v-card class="mx-2" elevation="2" outlined tile>
						<v-card class="d-flex pa-0" elevation="0">
							<v-card-text class="text-left">
								<h4>Transfer completion statistics</h4>
								<h4>(From {{ searchFilterTransfer.FromDate }} To {{ searchFilterTransfer.ToDate }})</h4>
							</v-card-text>
							<v-btn class="mx-2 my-2" fab light small color="#ff8517">
								<v-icon @click="transferFilterDialog = true" class="mdi-18px">mdi-filter</v-icon>
							</v-btn>
						</v-card>
						<apexchart type="line" height="430" :options="transferChartOptions" :series="transferDataSeries">
						</apexchart>
						<v-dialog transition="dialog-top-transition" v-model="transferFilterDialog" max-width="400">
							<v-card class="pa-4">
								<v-menu style="cursor:pointer" min-width="290px">
									<template v-slot:activator="{ on }">
										<v-text-field append-icon="mdi-chevron-down" prepend-icon="mdi-calendar"
											class="shrink my-auto" label="From Date" placeholder="Placeholder" outlined
											:value="searchFilterTransfer.FromDate" v-on="on">
											<template v-slot:append>
												<v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
											</template>
										</v-text-field>
									</template>
									<v-date-picker color="green lighten-1" v-model="searchFilterTransfer.FromDate">
									</v-date-picker>
								</v-menu>
								<v-menu min-width="290px">
									<template v-slot:activator="{ on }">
										<v-text-field append-icon="mdi-chevron-down" prepend-icon="mdi-calendar"
											class="shrink my-auto" label="To Date" placeholder="Placeholder" outlined
											:value="searchFilterTransfer.ToDate" v-on="on">
											<template v-slot:append>
												<v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
											</template>
										</v-text-field>
									</template>
									<v-date-picker elevation="5" color="green lighten-1"
										v-model="searchFilterTransfer.ToDate"></v-date-picker>
								</v-menu>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="#ff8517" fab light small
										@click="searchTransferWithParameters(); transferFilterDialog = false">
										<v-icon class="mdi-18px">mdi-magnify</v-icon>
									</v-btn>
									<v-btn color="#cccccc" fab light small @click="transferFilterDialog = false">
										<v-icon class="mdi-18px">mdi-close</v-icon>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</v-card>
				</v-col>
				<v-col cols="12" sm="6">
					<v-card class="mx-2" elevation="2" outlined tile>
						<v-card class="d-flex" elevation="0">
							<v-card-text class="text-left">
								<h4>Percentage of correspondences "Completed" vs "In progress"</h4>
								<h4>(From {{ searchFilterCorrespondences.FromDate }} To
									{{ searchFilterCorrespondences.ToDate }})</h4>
							</v-card-text>
							<v-btn class="mx-2 my-2" fab light small color="#ff8517">
								<v-icon @click="correspondencesFilterDialog = true" class="mdi-18px">mdi-filter</v-icon>
							</v-btn>
						</v-card>
						<apexchart type="pie" height="440" :options="correspondencesChartOptions"
							:series="correspondencesDataSeries">
						</apexchart>
						<v-dialog transition="dialog-top-transition" v-model="correspondencesFilterDialog" max-width="400">
							<v-card class="pa-4">
								<v-menu min-width="290px">
									<template v-slot:activator="{ on }">
										<v-text-field append-icon="mdi-chevron-down" prepend-icon="mdi-calendar"
											class="shrink my-auto" label="From Date" placeholder="Placeholder" outlined
											:value="searchFilterCorrespondences.FromDate" v-on="on">
											<template v-slot:append>
												<v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
											</template>
										</v-text-field>
									</template>
									<v-date-picker color="green lighten-1" v-model="searchFilterCorrespondences.FromDate">
									</v-date-picker>
								</v-menu>
								<v-menu min-width="290px">
									<template v-slot:activator="{ on }">
										<v-text-field append-icon="mdi-chevron-down" prepend-icon="mdi-calendar"
											class="shrink my-auto" label="To Date" placeholder="Placeholder" outlined
											:value="searchFilterCorrespondences.ToDate" v-on="on">
											<template v-slot:append>
												<v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
											</template>
										</v-text-field>
									</template>
									<v-date-picker elevation="5" color="green lighten-1"
										v-model="searchFilterCorrespondences.ToDate"></v-date-picker>
								</v-menu>
								<v-select label="Select Categories" v-model="searchFilterCorrespondences.CategoryIds"
									multiple chips hint="Pick Categories" persistent-hint :items="dropDown" dense
									append-icon="mdi-chevron-down"
									prepend-icon="mdi-checkbox-multiple-marked-circle-outline">
								</v-select>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="#ff8517" fab light small
										@click="searchGetDocumentsCompletedAndInProgressByUser(); correspondencesFilterDialog = false">
										<v-icon class="mdi-18px">mdi-magnify</v-icon>
									</v-btn>
									<v-btn color="#cccccc" fab light small
										@click="correspondencesFilterDialog = false; searchFilterCorrespondences.CategoryIds = []">
										<v-icon class="mdi-18px">mdi-close</v-icon>
									</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>
<style scoped>
.v-btn .v-icon:hover {
	color: white;
}
</style>
<script>
import axios from "axios";
import constants from "@/assets/js/constants.js";
import * as utils from '@/assets/js/common.js'

export default {
	name: "UserDashboards",
	data: function () {
		const vm = this;
		return {
			utils: utils,
			correspondencesDataSeries: [],
			transferDataSeries: [{
				name: "Average in day(s)",
				data: []
			}],
			searchFilterCorrespondences: {
				FromDate: "2022-01-01",
				ToDate: "",
				CategoryIds: [],
			},
			searchFilterTransfer: {
				FromDate: "2022-01-01",
				ToDate: ""
			},
			completedCorrespondencesValue: 0,
			transferFilterDialog: false,
			correspondencesFilterDialog: false,
			dropDown: [
				{ text: 'Incoming', value: 1 },
				{ text: 'Outgoing', value: 2 },
				{ text: 'Internal', value: 3 }
			],
			transferChartOptions: {
				chart: {
					height: 350,
					type: 'line',
					zoom: {
						enabled: false
					}
				},
				noData: {
					text: "No Data",
					align: "center",
					verticalAlign: "middle",
				},
				dataLabels: {
					enabled: false
				},
				stroke: {
					curve: 'straight'
				},
				title: {
					text: 'Transfer History',
					align: 'left'
				},
				grid: {
					row: {
						colors: ['#f3f3f3', 'transparent'],
						opacity: 0.5
					},
				},
				xaxis: {
					categories: ['My Transfers', 'All Transfers'],
				},
			},
			correspondencesChartOptions: {
				chart: {
					width: 380,
					type: "pie",
				},
				noData: {
					text: "No data text",
					align: "center",
					verticalAlign: "middle",
				},
				labels: ["InProgress", "Completed"],
				responsive: [
					{
						breakpoint: 300,
						options: {
							chart: {
								width: 200
							},
							legend: {
								position: "bottom",
							},
						},
					},
				],
				tooltip: {
					y: {
						formatter: function (value, { correspondencesDataSeries, seriesIndex, dataPointIndex, w }) {
							const myval = vm.completedCorrespondencesValue;
							return myval;
						}
					}
				},
			},
		};
	},
	methods: {
		searchTransferWithParameters: async function () {
			try {
				var formData = new FormData();
				formData.append('FromDate', utils.dateFormat(this.searchFilterTransfer.FromDate));
				formData.append('ToDate', utils.dateFormat(this.searchFilterTransfer.ToDate));

				const response = await axios
					.post(constants.ctsApiUrl + "Dashboard/GetTransferAverageCompletionTimeByUser", formData, {
						headers: constants.headers,
					})

				if (response.data.averageTransfers > 0) {
					const newresponse = this.getDurationFromSeconds(response.data.averageCreatedByUser, response.data.averageTransfers)

					const myobj = {
						name: "Average in day(s)",
						data: []
					}

					myobj.data.push(newresponse[0]);
					myobj.data.push(newresponse[1]);

					this.transferDataSeries = [];
					this.transferDataSeries.push(myobj);
				}
				else {
					this.transferDataSeries = [];
				}
			}
			catch (error) {
				console.log(error);
			}
		},
		searchGetDocumentsCompletedAndInProgressByUser: async function () {
			try {
				var formData = new FormData();
				formData.append('FromDate', utils.dateFormat(this.searchFilterCorrespondences.FromDate));
				formData.append('ToDate', utils.dateFormat(this.searchFilterCorrespondences.ToDate));
				if (this.searchFilterCorrespondences.CategoryIds.length > 0) {
					formData.append('CategoryIds', this.searchFilterCorrespondences.CategoryIds);
				}

				const response = await axios
					.post(constants.ctsApiUrl + "Dashboard/GetDocumentsCompletedAndInProgressByUser", formData, {
						headers: constants.headers,
					});

				if (response.data.length > 0) {
					if (response.data[1].count > 0) {
						this.completedCorrespondencesValue = response.data[1].count;

						const values = [];
						response.data.forEach(element => {
							values.push(element.count)
						});

						this.correspondencesDataSeries = [];
						await this.setCorrespondencesValues(values)
					}
					else {
						this.correspondencesDataSeries = [];
					}
				}
			}
			catch (error) {
				console.log(error)
			}
		},
		GetTransferAverageCompletionTimeByUser: async function () {
			try {
				var formData = new FormData();
				formData.append('FromDate', utils.dateFormat(this.searchFilterTransfer.FromDate));
				formData.append('ToDate', utils.dateFormat(this.searchFilterTransfer.ToDate));

				const response = await axios
					.post(constants.ctsApiUrl + "Dashboard/GetTransferAverageCompletionTimeByUser", formData, {
						headers: constants.headers,
					})

				if (response.data.averageTransfers > 0) {
					const newresponse = this.getDurationFromSeconds(response.data.averageCreatedByUser, response.data.averageTransfers)

					const myobj = {
						name: "Average in day(s)",
						data: []
					}

					myobj.data.push(newresponse[0]);
					myobj.data.push(newresponse[1]);

					this.transferDataSeries = [];
					this.transferDataSeries.push(myobj);
				}
				else {
					this.transferDataSeries = [];
				}
			}
			catch (error) {
				console.log(error);
			}
		},
		GetDocumentsCompletedAndInProgressByUser: async function () {
			try {
				var formData = new FormData();
				formData.append('FromDate', utils.dateFormat(this.searchFilterCorrespondences.FromDate));
				formData.append('ToDate', utils.dateFormat(this.searchFilterCorrespondences.ToDate));

				const response = await axios
					.post(constants.ctsApiUrl + "Dashboard/GetDocumentsCompletedAndInProgressByUser", formData, {
						headers: constants.headers,
					});

				if (response.data.length > 0) {
					this.completedCorrespondencesValue = response.data[1].count;
					const values = [];
					response.data.forEach(element => {
						values.push(element.count)
					});

					await this.setCorrespondencesValues(values)
				}
			}
			catch (error) {
				console.log(error)
			}
		},
		setToDate: function () {
			var today = new Date();
			var dd = String(today.getDate()).padStart(2, '0');
			var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
			var yyyy = today.getFullYear();

			today = yyyy + '-' + mm + '-' + dd;

			this.searchFilterTransfer.ToDate = today;
			this.searchFilterCorrespondences.ToDate = today;
		},
		setCorrespondencesValues: function (values) {
			var totalCount = values.reduce((a, b) => a + b, 0)
			var totalCount = 100 / totalCount;
			var InProgressPercentage = values[0] * totalCount;
			var CompletePercentage = values[1] * totalCount;

			this.correspondencesDataSeries.push(InProgressPercentage);
			this.correspondencesDataSeries.push(CompletePercentage)
		},
		getDurationFromSeconds: function (aSecond, bSecond) {
			aSecond = Number(aSecond);
			var aDays = Math.floor(aSecond / (3600 * 24));
			var aHours = Math.floor(aSecond % (3600 * 24) / 3600);
			var aMinutes = Math.floor(aSecond % 3600 / 60);
			var aSeconds = Math.floor(aSecond % 60);
			bSecond = Number(bSecond);
			var bDays = Math.floor(bSecond / (3600 * 24));
			var bHours = Math.floor(bSecond % (3600 * 24) / 3600);
			var bMinutes = Math.floor(bSecond % 3600 / 60);
			var bSeconds = Math.floor(bSecond % 60);
			var aDaysDisplay = aDays >= 0 ? aSecond / (3600 * 24) : 0;
			var aHoursDisplay = aHours >= 0 ? aSecond % (3600 * 24) / 3600 : 0;
			var aMinutesDisplay = aMinutes >= 0 ? aSecond % 3600 / 60 : 0;
			var aSecondsDisplay = aSeconds >= 0 ? aSecond % 60 : 0;
			var bDaysDisplay = bDays >= 0 ? bSecond / (3600 * 24) : 0;
			var bHoursDisplay = bHours > 0 ? bSecond % (3600 * 24) / 3600 : 0;
			var bMinutesDisplay = bMinutes > 0 ? bSecond % 3600 / 60 : 0;
			var bSecondsDisplay = bSeconds > 0 ? bSecond % 60 : 0;

			if (aDays > 0 || bDays > 0) {
				return [parseFloat(aDaysDisplay).toFixed(2), parseFloat(bDaysDisplay).toFixed(2), "Average"];
			}

			if (aHours > 0 || bHours > 0) {
				return [parseFloat(aHoursDisplay).toFixed(2), parseFloat(bHoursDisplay).toFixed(2), "Average in Hours"];
			}

			if (aMinutes > 0 || bMinutes > 0) {
				return [parseFloat(aMinutesDisplay).toFixed(2), parseFloat(bMinutesDisplay).toFixed(2), "Average in Minutes"];
			}

			if (aSeconds > 0 || bSeconds > 0) {
				return [parseFloat(aSecondsDisplay).toFixed(2), parseFloat(bSecondsDisplay).toFixed(2), "Average in Seconds"];
			}
		}
	},
	mounted() {
		this.setToDate();
		this.GetTransferAverageCompletionTimeByUser();
		this.GetDocumentsCompletedAndInProgressByUser();
	},
};
</script>